import Wrapper from "@/components/layout/Wrapper";
import MainHome from "../pages/homes/home_10";

import MetaComponent from "@/components/common/MetaComponent";
import JsonLd from "@/components/common/JsonLd";

const metadata = {
  title: "Tanie wakacje i loty w elastycznych terminach | tripsi.pl",
  description: "Tripsi porównuje loty i hotele w wielu terminach, aby znaleźć najtańsze wakacje z polskich lotnisk.",
  // Search Console flagged https://tripsi.pl/ and https://www.tripsi.pl/ as duplicates with no
  // user-selected canonical - pins the signal to the non-www host (also enforced by a redirect,
  // see vercel.json) so both a crawl that somehow still reaches www and the canonical tag agree.
  canonical: "https://tripsi.pl/",
};

// Organization + WebSite schema on the homepage - a one-time, site-wide "who is this" block
// rather than something every page needs to repeat. Helps both classic rich results (sitelinks
// search box) and entity grounding for LLM answer engines / knowledge panels, which lean on
// exactly this kind of unambiguous, structured self-description when deciding whether/how to
// cite a source.
const organizationSchema = [
  {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "tripsi.pl",
    url: "https://tripsi.pl",
    description: "Wyszukiwarka tanich lotów i wakacji z polskich lotnisk (Ryanair, Wizz Air i inni tani przewoźnicy).",
    logo: "https://tripsi.pl/img/general/logo.svg",
    email: "kontakt@tripsi.pl",
    contactPoint: {"@type": "ContactPoint", contactType: "customer support", email: "kontakt@tripsi.pl", availableLanguage: ["pl"]},
  },
  {
    "@context": "https://schema.org",
    "@type": "WebSite",
    name: "tripsi.pl",
    url: "https://tripsi.pl",
    potentialAction: {
      "@type": "SearchAction",
      target: "https://tripsi.pl/tour-list-v1?destination={search_term_string}",
      "query-input": "required name=search_term_string",
    },
  },
];

export default function Home() {
  return (
    <>
      <MetaComponent meta={metadata} />
      <JsonLd data={organizationSchema} />
      <Wrapper>
        <MainHome />
      </Wrapper>
    </>
  );
}
